import React from 'react';
import { TextInput } from '../text';
import { PasswordInputProps } from './model';

export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>((props, ref) => {
  return <TextInput htmlType="password" placeholder="Password" ref={ref} {...props} />;
});
